const BaseParticle = require('BaseParticle');
const PSRand = require('PSRand');

const State = cc.Enum({
    ENABLED: 'enabled',
    DISABLED: 'disabled'
});

const SPEED = 500;

cc.Class({
    extends: cc.Component,

    properties: {
        prefab: cc.Prefab,
        poolInitialLength: 200,
        topLayerRatio: 0.9,
        topContainer: cc.Node,
        bottomContainer: cc.Node,
        deltaX: 400,
        yDistance: 1500,
        yDistanceSkewCoefficient: 0.5,
        soundOptionName: '[note that the sound option should be listend in AudioMap component'
    },

    onLoad () {
        this.poolTypeMap = [];
        this.pool = new cc.NodePool(cc.Component);
        this.audioID = null;

        for (let i = 0; i < this.poolInitialLength; i++) {
            this.pool.put(cc.instantiate(this.prefab));
        }
        this.state = State.DISABLED;

        this.audioManager = cc.find('AudioManager').getComponent('AudioManager');
        this.audioMap = cc.find('AudioMap').getComponent('AudioMap');
        this.hasSound = this.soundOptionName && this.soundOptionName.length && this.audioMap.hasOwnProperty(this.soundOptionName);
    },

    play (freq, speed) {
        if (this.hasSound && !this.audioID) {
            this.audioID = this.audioManager.play(this.audioMap[this.soundOptionName]);
        }

        this.speed = speed || SPEED;
        if (this.state === State.ENABLED) {
            this.stop(); // check if enabled, stop if yes
        }
        this.state = State.ENABLED;

        this.schedule(() => {
            const pooledItem = this.createParticle();
            const deltaX = this._calculateDeltaX();

            this._fall(pooledItem, this.yDistance, deltaX);

        }, 1 / freq);
    },

    stop () {
        if (this.audioID) {
            this.audioManager.fadeOutSfx(1000, this.audioID, true);
            this.audioID = null;
        }
        this.unscheduleAllCallbacks();
        this.state = State.DISABLED;
    },

    createParticle () {
        let item;

        if (!this.pool.size()) {
            item = cc.instantiate(this.prefab);
        } else {
            item = this.pool.get();
        }
        const isTopLayer = Math.random() < this.topLayerRatio;
        const container = isTopLayer ? this.topContainer : this.bottomContainer;

        item.parent = container;
        const itemController = item.getComponent(BaseParticle);

        item.x = this.node.width * Math.random() - this.node.width / 2;
        item.y = 0;
        item.active = true;
        itemController.play(isTopLayer);
        return itemController;
    },

    _calculateDeltaX () {
        const x = this.deltaX  / 2 - this.deltaX * Math.random();

        return x;
    },

    _fall (item, distance, deltaX) {
        const rValue = PSRand.floatRange(1 - this.yDistanceSkewCoefficient, 1 + this.yDistanceSkewCoefficient);
        const actualSpeed = this.speed * rValue;
        const time = Math.abs(distance) / actualSpeed;
        const container = item.node;

        cc.tween(container).
        by(time, { x: deltaX, y: -distance }).
        call(() => {
            item.node.active = false;
            this.pool.put(item.node);
        }).
        start();
    }
});
